var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPulse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_7316)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7727 6.72725C12.9924 6.94692 12.9924 7.30308 12.7727 7.52272L9.62272 10.6727C9.50355 10.7919 9.33727 10.8514 9.16957 10.8347C9.00187 10.8181 8.85045 10.7272 8.757 10.587L7.93755 9.3579L6.02275 11.2727C5.80308 11.4924 5.44692 11.4924 5.22725 11.2727C5.00758 11.053 5.00758 10.6969 5.22725 10.4773L7.62727 8.07727C7.74645 7.9581 7.91272 7.89862 8.08042 7.91527C8.24812 7.93185 8.39955 8.02275 8.493 8.163L9.31245 9.3921L11.9773 6.72725C12.1969 6.50758 12.553 6.50758 12.7727 6.72725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3125 7.125C10.3125 6.81434 10.5644 6.5625 10.875 6.5625H12.375C12.6857 6.5625 12.9375 6.81434 12.9375 7.125V8.625C12.9375 8.93565 12.6857 9.1875 12.375 9.1875C12.0644 9.1875 11.8125 8.93565 11.8125 8.625V7.6875H10.875C10.5644 7.6875 10.3125 7.43566 10.3125 7.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.321 2.321C3.32186 1.32015 4.81952 0.9375 6.75 0.9375H11.25C13.1805 0.9375 14.6782 1.32015 15.679 2.321C16.6799 3.32186 17.0625 4.81952 17.0625 6.75V11.25C17.0625 13.1805 16.6799 14.6782 15.679 15.679C14.6782 16.6799 13.1805 17.0625 11.25 17.0625H6.75C4.81952 17.0625 3.32186 16.6799 2.321 15.679C1.32015 14.6782 0.9375 13.1805 0.9375 11.25V6.75C0.9375 4.81952 1.32015 3.32186 2.321 2.321ZM3.1165 3.1165C2.42985 3.80315 2.0625 4.93048 2.0625 6.75V11.25C2.0625 13.0695 2.42985 14.1968 3.1165 14.8835C3.80315 15.5702 4.93048 15.9375 6.75 15.9375H11.25C13.0695 15.9375 14.1968 15.5702 14.8835 14.8835C15.5702 14.1968 15.9375 13.0695 15.9375 11.25V6.75C15.9375 4.93048 15.5702 3.80315 14.8835 3.1165C14.1968 2.42985 13.0695 2.0625 11.25 2.0625H6.75C4.93048 2.0625 3.80315 2.42985 3.1165 3.1165Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_7316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulse);
export default __webpack_public_path__ + "static/media/pulse.1db7a37781063116296693aa4b9244af.svg";
export { ForwardRef as ReactComponent };